import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EtjansterSites } from '@vinnova/e-tjanster';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  standalone: false,
})
export class PublicLayoutComponent implements OnInit {
  environmentInfoText$: Observable<string>;
  isProduction: boolean;

  EtjansterSites = EtjansterSites;

  ngOnInit() {
    this.isProduction = environment.production;
  }
}
